var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "menu mega-menu", attrs: { id: "primary-menu" } },
    [
      _c("div", { staticClass: "underlay" }),
      _vm._v(" "),
      _vm._l(_vm.navigation, function (item) {
        return _c(
          "li",
          {
            key: item.ID,
            class: [
              "menu-item",
              "menu-item-type-custom",
              "menu-item-object-custom",
              "menu-item-" + item.ID,
              { "has-children": item.children },
            ],
            on: { mouseover: _vm.$root.closeLangSwitcher },
          },
          [
            item.trigger_lead_popup
              ? _c("span", {
                  staticClass: "main-item",
                  domProps: { innerHTML: _vm._s(item.title) },
                  on: { click: _vm.$root.toggle_popup },
                })
              : _c("a", {
                  staticClass: "main-item",
                  class: item.is_current ? "current" : "",
                  attrs: { href: item.url },
                  domProps: { innerHTML: _vm._s(item.title) },
                }),
            _vm._v(" "),
            _c("div", { staticClass: "hover-helper" }, [
              _c("span", { domProps: { innerHTML: _vm._s(item.title) } }),
            ]),
            _vm._v(" "),
            Object.keys(item.children).length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "sub-menu-wrapper",
                    on: { mouseleave: _vm.resetMenu },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "sub-menu-items",
                        class: _vm.someChildHasChildren(item.children)
                          ? "two-levels"
                          : "",
                      },
                      _vm._l(item.children, function (child) {
                        return _c(
                          "div",
                          { key: child.ID, staticClass: "sub-menu-item" },
                          [
                            _vm.someChildHasChildren(item.children)
                              ? _c("div", [
                                  _c("div", { staticClass: "top" }, [
                                    _c("span", {
                                      staticClass: "title",
                                      domProps: {
                                        innerHTML: _vm._s(child.title),
                                      },
                                    }),
                                    _vm._v(" "),
                                    child.subtitle
                                      ? _c("p", {
                                          staticClass: "small subtitle",
                                          domProps: {
                                            innerHTML: _vm._s(child.subtitle),
                                          },
                                        })
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "items" },
                                    _vm._l(child.children, function (subchild) {
                                      return _c("div", { key: subchild.ID }, [
                                        subchild.trigger_lead_popup
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "a",
                                                class: subchild.is_current
                                                  ? "current"
                                                  : "",
                                                on: {
                                                  click: _vm.$root.toggle_popup,
                                                },
                                              },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      subchild.title
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      width: "16",
                                                      height: "16",
                                                      viewBox: "0 0 16 16",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                                        fill: "#CA1744",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                                        fill: "#CA1744",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "a",
                                              {
                                                class: subchild.is_current
                                                  ? "current"
                                                  : "",
                                                attrs: { href: subchild.url },
                                              },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      subchild.title
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      width: "16",
                                                      height: "16",
                                                      viewBox: "0 0 16 16",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                                        fill: "#CA1744",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                                        fill: "#CA1744",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ])
                                    }),
                                    0
                                  ),
                                ])
                              : _c("div", { staticClass: "item" }, [
                                  child.trigger_lead_popup
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "a",
                                          class: child.is_current
                                            ? "current"
                                            : "",
                                          on: { click: _vm.$root.toggle_popup },
                                        },
                                        [
                                          _c("span", [
                                            _c("span", {
                                              staticClass: "title",
                                              domProps: {
                                                innerHTML: _vm._s(child.title),
                                              },
                                            }),
                                            _vm._v(" "),
                                            child.subtitle
                                              ? _c("p", {
                                                  staticClass: "small subtitle",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      child.subtitle
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 16 16",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                                  fill: "#CA1744",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                                  fill: "#CA1744",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          class: child.is_current
                                            ? "current"
                                            : "",
                                          attrs: { href: child.url },
                                        },
                                        [
                                          _c("span", [
                                            _c("span", {
                                              staticClass: "title",
                                              domProps: {
                                                innerHTML: _vm._s(child.title),
                                              },
                                            }),
                                            _vm._v(" "),
                                            child.subtitle
                                              ? _c("p", {
                                                  staticClass: "small subtitle",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      child.subtitle
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 16 16",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                                  fill: "#CA1744",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                                  fill: "#CA1744",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.featuredToUse(item)
                      ? _c(
                          "div",
                          { staticClass: "featured" },
                          _vm._l(_vm.featuredToUse(item), function (feature) {
                            return _c("div", { staticClass: "feature" }, [
                              _c("a", { attrs: { href: feature.link } }, [
                                _c("div", { staticClass: "top" }, [
                                  feature.tagline
                                    ? _c("span", {
                                        staticClass: "small",
                                        domProps: {
                                          innerHTML: _vm._s(feature.tagline),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  feature.headline
                                    ? _c("span", {
                                        staticClass: "title",
                                        domProps: {
                                          innerHTML: _vm._s(feature.headline),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  feature.short_description
                                    ? _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            feature.short_description
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "image" }, [
                                  feature.image
                                    ? _c("img", {
                                        attrs: { src: feature.image, alt: "" },
                                      })
                                    : _vm._e(),
                                ]),
                              ]),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }